import React from "react";
import GeoWorkspace from "../shared/GeoWorkspace.jsx";
export default function EDGeoWorkspace(props) {
    return <GeoWorkspace role="ED" {...props} />;
}
